import React, { useState, useEffect } from "react";

import {
  ButtonBack,
  ButtonNext,
  CarouselProvider,
  Image,
  Slide,
  Slider,
} from "pure-react-carousel";

import { Link, navigate } from "gatsby";
import "pure-react-carousel/dist/react-carousel.es.css";

import { FiChevronRight } from "@react-icons/all-files/fi/FiChevronRight";

import { FiChevronLeft } from "@react-icons/all-files/fi/FiChevronLeft";
import { store } from "../../store/store";
import { observer } from "mobx-react-lite";

import "./ItemSlider.style.scss";

import img from '../../assets/seperator.svg';

const isBrowser = () => typeof window !== "undefined";

const ItemSlider = observer(({ total, loop, sub }) => {
  const [width, setWidth] = useState(isBrowser() && window.innerWidth);
  const updateDimensions = () => {
    setWidth(isBrowser() && window.innerWidth);
  };

  const link =
    store.language === "english" ? `/${sub}/` : `/${sub}/${store.language}/`;

  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  return (
    <div className="slidepar ItemSlider">
      <CarouselProvider
        className="carousel"
        visibleSlides={
          total <= 8
            ? total <= 5
              ? width < 550
                ? 2
                : total
              : width < 550
              ? 2
              : width < 750
              ? 3
              : width > 1050
              ? 6
              : 5
            : width < 900
            ? width < 550
              ? 2
              : width < 750
              ? 3
              : width > 1050
              ? 6
              : 5
            : 8
        }
        totalSlides={total}
        step={2}
        naturalSlideWidth={8}
        naturalSlideHeight={12.5}
        //naturalSlideHeight={100.5}

        hasMasterSpinner={false}
        infinite
      >
        <Slider>
          {loop.map((v, k) => (
            <Link key={k} to={link + v.slug} index={k}>
              <Slide onClick={() => navigate(link + v.slug)}>
                <div>
                  <div>
                    <Image src={v.icon.localFile.publicURL} />
                  </div>
                  <div>
                    <p className="caroseltitle">
                      {store.language === "hindi"
                        ? v.titleHindi || v.hindiTitle
                        : v.title}
                    </p>
                  </div>
                </div>
              </Slide>
            </Link>
          ))}
        </Slider>

        <ButtonBack className="back btt">
          <FiChevronLeft />
        </ButtonBack>
        <ButtonNext className="next btt">
          <FiChevronRight />
        </ButtonNext>
      </CarouselProvider>
    </div>
  );
});



export function ItemSliderGrid ({loop, sub}){
  const link =
  store.language === "english" ? `/${sub}/` : `/${sub}/${store.language}/`;
  
  return <div className="itemG-container">
    {loop.map((v,key)=>
      <Link key={key} to={link + v.slug} index={key} className="itemG">
      <img className="itemG-icon" src={v.icon.localFile.publicURL} alt="" width={50} style={{height:50}}/>
      <div className="itemG-title">{v.title.split(" ")[0]}</div>
      <img src={img} alt="" width={70} style={{marginTop:5}}/>
      <p className="itemG-description">{v.description}</p>
      </Link>)}
  </div>
}

export function SimpleGrid({loop,sub}){

  return <div className="itemG-container">
  {loop.map((v,key)=>
    <Link key={key} to={"/"+ sub +"/" +v.slug} 
    //to={link + v.slug} 
    index={key} className="itemG">
    <div className="itemG-title">{v.title.split(" ")[0]}</div>
    <p className="itemG-description">{v.description}</p>
    </Link>)}
</div>
}

export default ItemSlider;
